import axios from 'axios';

const baseURL = `https://wherespoppin-server.onrender.com/api`
axios.defaults.baseURL = baseURL;
const instance = axios;

// const axiosIns = axios.create({
//   baseURL: baseURL
// });

// export default axiosIns
export default instance